import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuToggleOption} from '@Components/contextual-menu/components/contextual-menu-toggle-option';
import {PageGridSizeOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/page-grid-size-option';
import {useAppSelector} from '@/hooks';

export function PageGridOption(): ReactElement<any> | null {
  const isGridEnabled = useAppSelector((state) => {
    return state.posterEditor.posterObject?.grid.enabled;
  });

  if (isGridEnabled === undefined) {
    return null;
  }

  const getToggleSubOption = (): ReactElement<any> | null => {
    if (isGridEnabled) {
      return <PageGridSizeOption />;
    }
    return null;
  };

  return (
    <ContextualMenuToggleOption
      id="page-grid-option"
      label={window.i18next.t('pmwjs_grid')}
      isChecked={isGridEnabled}
      onClick={(): void => {
        void window.posterEditor?.whiteboard?.updateFromObject(
          {
            grid: {
              enabled: !isGridEnabled,
            },
          },
          {
            undoable: false,
          }
        );
      }}
    >
      {getToggleSubOption()}
    </ContextualMenuToggleOption>
  );
}
